import React from "react";
import { RxAvatar } from "react-icons/rx";
import { Link, useLocation } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { AiFillDollarCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { logOut } from "../../store/slices/ownerSlice";
type Props = {};

const settings = [
  {
    title: "Profile",
    key: "profile",
    path: "/settings/profile",
    icon: <RxAvatar size={20} />,
  },
  {
    title: "Billing",
    key: "billing",
    path: "/settings/billing",
    icon: <AiFillDollarCircle size={20} />,
  },
  // {
  //   title: "Account Activity",
  //   key: "account",
  //   path: "/settings/account-activity",
  //   icon: <FiActivity size={20} />,
  // },
  //   {
  //     title: "Notification",
  //     key: "notification",
  //   },
  //   {
  //     title: "Security",
  //     key: "security",
  //   },
];

const SettingSider = (props: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  return (
    <div className="flex w-full">
      <ul className="flex w-full gap-2 lg:flex-col lg:gap-0">
        {settings.map((setting) => (
            <li
            key={setting.key}
            className="my-0 shrink-0 lg:my-2"
          >
            <Link
              to={setting.path}
              className={[
                "flex w-full items-center gap-2 rounded-[8px] border px-3 py-2.5 text-sm font-medium transition-colors",
                location.pathname === setting.path
                  ? "border-brand-blue bg-bg-light-blue text-brand-blue"
                  : "border-light-grey bg-white text-dark-black hover:bg-primary",
              ].join(" ")}
            >
              {setting.icon}
              <p>{setting.title}</p>
            </Link>
          </li>
        ))}
        <li className="my-0 shrink-0 lg:my-2">
          <button
            type="button"
            onClick={() => dispatch(logOut())}
            className="flex w-full items-center gap-2 rounded-[8px] border border-light-grey bg-white px-3 py-2.5 text-sm font-medium text-dark-black transition-colors hover:bg-primary"
          >
            <FiLogOut size={20} />
            <p>Logout</p>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default SettingSider;
